import store from "../store";
import { toast } from "react-toastify";
import { RESPONSE_ERROR_LOGIN, ACCESS_DENIED, ERROR } from "../types/index";

export const handleApiError = (error, showErrorToast = true) => {
    if (error?.response?.status === 401) {
        store.dispatch({ type: RESPONSE_ERROR_LOGIN });
    }

    if (error?.response?.status === 403) {
        store.dispatch({
            type: ACCESS_DENIED,
            payLoad: { status: true, message: error?.response?.data },
        });
    }
   
    if (showErrorToast) {
        const message =
            error?.response?.data?.message ||
            error?.errorMessage ||
            "An unexpected error occurred";

        console.log("in toast error:", message);
        toast.error(message);
    }

    store.dispatch({ type: ERROR, payload: error });
};
